<template>
  <div class="page-scholarship-plan-product-list-2019"
       id="products"
  >
    <img class="header"
         :src="require('@/pages/2019/ScholarshipPlan/assets/img/course_header.png')"
         alt="课程标题"
    >
    <div class="nav-bar">
      <div class="nav-item"
           :class="{
             'active': currIndex === index,
             'active-0': currIndex === 0,
             'active-2': currIndex === 2,
           }"
           @click="handleNavBarClick(index)"
           v-ym-report:MARKETING_SCHOLARSHIP_2019_NAV_CLICK="{ index }"
           v-for="(item, index) in course"
           :key="index"
      >
        {{ item.date }}
      </div>
    </div>
    <div class="product-list">
      <a class="product-item"
         v-for="(item, index) in productList"
         :key="index"
         :href="item.productPath"
         :target="[ inPC ? '_blank' : '_self' ]"
v-ym-report:MARKETING_SCHOLARSHIP_2019_COURSE_CLICK|MARKETING_SCHOLARSHIP_2019_COURSE_EXPOSURE
           ="{ category: item.type, id: item.id }"
      >
        <img class="item-cover"
             :src="item.cover"
             alt="封面"
        >
        <div class="item-info">
          <div class="item-title ym-two-line-ellipsis" v-html="item.title"></div>
          <div>
            <del class="origin-price">原价 ¥{{ item.price }}</del>
            <div class="item-action">
              <div class="benefit-price">券后价 ¥{{ item.price - 200 }}</div>
              <div class="join-btn"
                   :class="{ 'is-member': item.isMember }"
              >
                {{ item.isMember ? '已报名' : '我要买课' }}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import { isPC } from '@/utils';

  export default {
    name: 'ScholarshipPlanProductList2019',
    props: {
      course: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        productList: [],
        currIndex: 0,
      };
    },
    computed: {
      inPC() {
        return isPC();
      },
      recordName() {
        return 'MARKETING_SCHOLARSHIP_2019_COURSE_CLICK|MARKETING_SCHOLARSHIP_2019_COURSE_EXPOSURE';
      },
    },
    methods: {
      handleNavBarClick(index) {
        this.productList = this.course[index].list;
        this.currIndex = index;
      },
    },
    created() {
      this.productList = this.course[0].list;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-scholarship-plan-product-list-2019 {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header {
    width: 670px;
    height: 108px;
    display: block;
  }

  .nav-bar {
    width: 690px;
    height: 80px;
    margin: @size-base auto;
    padding: 0 @size-extra-small / 2;
    box-sizing: border-box;
    background: #ff6964;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .nav-item {
    width: 222px;
    height: 70px;
    border-radius: 35px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: @font-weight-strong;
    font-size: @font-size-large;
    color: #fff5dd;
    position: relative;
    z-index: @z-index-medium;
    &.active {
      color: #3c4657;
      background: linear-gradient(to bottom, rgba(255,227,164,1), rgba(255,205,98,1));
      box-shadow: 0 6px 8px 0 rgba(234,88,72,0.6);
    }
    &.active-0 {
      &:nth-child(2) {
        &:after {
          position: absolute;
          content: '';
          width: 5px;
          height: 60px;
          background: #e75551;
          right: 0;
          top: 5px;
          z-index: @z-index-large;
          border-radius: 3px;
        }
      }
    }
    &.active-2 {
      &:nth-child(1) {
        &:after {
          position: absolute;
          content: '';
          width: 4px;
          height: 60px;
          background: #e75551;
          right: 0;
          top: 5px;
          z-index: @z-index-large;
          border-radius: 3px;
        }
      }
    }
  }

  .product-list {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }
  .product-item {
    width: 100%;
    padding: @size-base;
    box-sizing: border-box;
    border-radius: 30px;
    display: flex;
    background: @color-white;
    &:not(:last-child) {
      margin-bottom: @size-medium;
    }
  }
  .item-cover {
    width: 300px;
    height: 226px;
    margin-right: @size-base;
    border-radius: 10px;
    border: 1px solid fade(#ffb362, 50%);
  }
  .item-info {
    flex: 1;
    padding-top: @size-extra-small / 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .item-title {
    width: 100%;
    margin-bottom: @size-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-bold;
    color: @color-text-base;
    line-height: 1.4;
  }
  .origin-price {
    display: block;
    margin-bottom: @size-extra-small;
    padding-left: @size-extra-small;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    color: @color-text-lighter;
    line-height: 1;
  }
  .item-action {
    width: 344px;
    height: 60px;
    border-radius: 30px;
    overflow: hidden;
    display: flex;
  }
  .benefit-price {
    width: 194px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, rgba(255,227,164,1), rgba(255,205,98,1));
    font-size: @font-size-base;
    line-height: 1;
    color: #614616;
  }
  .join-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, rgba(255,142,81,1), rgba(255,99,99,1));
    font-size: @font-size-base;
    line-height: 1;
    color: @color-white;
    &.is-member {
      background: #ffb94c;
    }
  }

</style>
